import { changeQuoteLine } from '../actions';
import { connectEditor } from '../connect-editor';
import QuoteLinesBulkEditor from './QuoteLinesBulkEditor';

export default connectEditor(
  ({ productsById, quoteLinesById, quoteLinesSelection }) => {
    const quoteLines = Object.values(quoteLinesById).filter(
      ({ id }) => quoteLinesSelection[id],
    );

    const disabled = quoteLines.length === 0;

    return { disabled, productsById, quoteLines };
  },
  {
    changeQuoteLine,
  },
  (
    { productsById, quoteLines, ...otherStateProps },
    { changeQuoteLine: change },
  ) => {
    const onChange = (name, value) =>
      quoteLines.forEach(({ id, productId }) => {
        const product = productsById[productId];
        const { overwriteCategories, overwriteGender } = product;

        if (name === 'categories' && !overwriteCategories) return;
        if (name.includes('gender') && !overwriteGender) return;

        change(id, name, value);
      });

    return { ...otherStateProps, onChange, quoteLines };
  },
)(QuoteLinesBulkEditor);
